export default __webpack_public_path__ + "static/media/film.e0add22a.mp4";